<template>
  <div class="speedStudyPage">
    <div>
      <van-pull-refresh
        v-model="refreshing"
        style="min-height: 100vh"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="selfStudy">
            <Navbar
              :title="detail.title"
              :backNative="true"
              v-if="showTitle"
              style="position: absolute; top: 0; z-index: 9999"
              class="topNav"
            />

            <div class="bg">
              <img
                @click="toBack"
                :style="{ top: statusHeight + 'px' }"
                src="../../assets/images/backIcon.png"
                alt=""
              />
              <div class="courseType">
                <div class="typeInfo" ref="scrollOne">
                  <div class="typeTitle">{{ detail.title }}</div>
                  <div class="typeword">
                    {{ detail.joinCount }}人参与 | {{ detail.workCount }}个作业
                  </div>
                </div>
              </div>
            </div>

            <div class="content">
              <div class="contentTitle">作业日记</div>

              <div class="homeworkList">
                <div
                  class="homeworkCard"
                  v-for="(item, index) in list"
                  :key="index"
                  @click="toDetail(item.id)"
                >
                  <div class="card_left">
                    <img
                      :src="
                        item.avatar
                          ? item.avatar
                          : require('../../assets/images/default.png')
                      "
                      alt=""
                    />
                  </div>

                  <div class="card_right">
                    <div class="topInfo">
                      <div class="userInfo">
                        <div class="username">
                          <span>{{ item.name }}</span>
                          <div
                            class="chosenPic"
                            v-show="item.joinRecommend === 1"
                          >
                            <img src="../../assets/images/chosen.png" alt="" />
                          </div>
                        </div>
                        <div class="sendtime">{{ item.releaseTime }}</div>
                      </div>
                      <div class="learnDay">
                        已学习 <span>{{ item.studyTime }}</span
                        >天
                      </div>
                    </div>

                    <div class="homewordContent">
                      <div class="teacherWord">{{ item.title }}</div>
                      <div class="videoContent">
                        <img class="videoPoster" :src="item.image" alt="" />
                        <img
                          class="playicon"
                          src="../../assets/images/play.png"
                          alt=""
                        />
                      </div>
                    </div>

                    <div class="teacherCommend">
                      <img
                        class="commentIcon"
                        src="../../assets/images/commentIcon.png"
                        alt=""
                      />

                      <div class="commentWord">{{ item.teacherReview }}</div>

                      <div
                        class="picsList"
                        v-if="item.teacherPicture.length > 0"
                      >
                        <div
                          class="picItem"
                          v-for="(items, index) in item.teacherPicture"
                          :key="index"
                          :style="{
                            background:
                              'url(' +
                              item.teacherPicture[index] +
                              ') no-repeat center center',
                            backgroundSize: '100% auto',
                          }"
                        ></div>
                      </div>
                      <div class="line"></div>

                      <div class="teacherInfo">
                        <img
                          :src="
                            item.teacherAvatar
                              ? item.teacherAvatar
                              : require('../../assets/images/default.png')
                          "
                          alt=""
                        />
                        <span>{{ item.teacherName }}</span>
                      </div>
                    </div>
                    <div class="pariseNum">获赞{{ item.thumbCount }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import Navbar from "../../components/NavBar";
import http from "../../utils/http";

export default {
  data() {
    return {
      showTitle: false,
      list: [], //作业区
      loading: false, //是否正在加载
      finished: false, //是否结束
      refreshing: false, //是否正在刷新
      detail: {},
      current: 1,
      size: 20,
      type: 0,
      isApp: true,
    };
  },
  components: {
    Navbar,
  },
  computed: {
    statusHeight() {
      return this.$store.state.statusHeight;
    },
    isInit() {
      return this.$store.state.refreshPage;
    },
  },
  mounted() {
    // this.initPage()
    window.addEventListener("scroll", this.handleScroll);

    this.$nextTick(() => {
      if (this.isInit) {
        this.initPage();
      }
      // this.initPage()
    });
    // this.initPage()
    // this.getCourseList()
  },
  methods: {
    initPage() {
      this.init = true;

      this.current = 1;
      //  this.list=[]
      this.getCourseList();
    },
    //获取列表
    getCourseList() {
      let query = this.$route.query;
      this.type = query.classType;
      http
        .getCourseWork({
          current: this.current,
          size: this.size,
          classType: query.classType,
          CourseDetailId: query.CourseDetailId,
        })
        .then((res) => {
          setTimeout(() => {
            if (res.memberWorkList.length > 0) {
              // console.log(res.memberWorkList)
              let newList = res.memberWorkList;
              newList.map((item) => {
                if (item.teacherPicture) {
                  item.teacherPicture = item.teacherPicture.split(",");
                } else {
                  item.teacherPicture = [];
                }
              });
              // console.log(newList)
              if (this.refreshing) {
                // this.list = [...res.memberWorkList];
                this.list = [...newList];
                this.refreshing = false;
              } else {
                // this.list = [...this.list, ...res.memberWorkList];
                this.list = [...this.list, ...newList];
              }
              this.loading = false;

              if (res.memberWorkList.length < 20) {
                this.finished = true;
              }
            } else {
              this.finished = true;
              this.current--;
            }
          }, 500);
          console.log(res);
          this.detail = res;
        });
    },



    toDetail(id) {
      this.$router.push({
        path: "/workDetail",
        query: { id, type: this.type },
      });
    },
    //页面滚动
    handleScroll() {
      //获取滚动时的高度
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let oneHeight = this.$refs.scrollOne.offsetHeight;
      //
      // console.log(scrollTop);

      if (scrollTop > oneHeight) {
        //这是滑动到scrollTwo的距离要做的操作
        this.showTitle = true;
      } else {
        this.showTitle = false;
      }
    },
    onLoad() {
      if (this.refreshing) {
      } else {
        this.current++;
      }

      this.getCourseList();
    },

    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.current = 1;
      this.onLoad();
    },
    toBuyedPage() {
      this.$router.push({
        path: "/BuyedCourse",
      });
    },
    toBack() {
      //返回上一页
      this.$store.commit("Set_refresh", true);
      if (this.isApp) {
        http.guitarAppListener("backToNative", {});
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.speedStudyPage {
  position: relative;
  min-height: 100vh;
}
.selfStudy {
  display: flex;
  flex-direction: column;
  position: relative;

  .bg {
    width: 100%;
    height: 194px;
    background: url("../../assets/images/homeWorkBg.png");
    background-size: 100% 100%;
    position: relative;
    overflow: hidden;
    img {
      width: 22px;
      height: 22px;
      position: absolute;
      top: 14px;
      left: 16px;
    }
    .courseType {
      width: calc(100% - 32px);
      margin: 0 auto;
      margin-top: 76px;
      display: flex;
      justify-content: space-between;
      align-items: "center";
      .typeInfo {
        .typeTitle {
          font-size: 24px;

          font-weight: bold;
          color: #fff;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .typeword {
          font-size: 13px;
          color: #cacacc;
          margin-top: 4px;
        }
      }
      .countWord {
        font-size: 13px;
        color: #cacacc;
        margin-top: 2px;
        margin-bottom: 6px;
      }
    }
  }

  .content {
    width: 100%;
    flex: 1;
    background: #ffffff;
    border-radius: 16px 16px 0px 0px;
    margin-top: -18px;
    position: relative;
    z-index: 99;
    padding: 0 16px;
    box-sizing: border-box;

    .contentTitle {
      margin-top: 24px;
      font-size: 20px;
      font-weight: bold;
    }

    .homeworkList {
      .homeworkCard {
        display: flex;
        justify-content: space-between;
        margin-top: 16px;
        padding-bottom: 16px;
        border-bottom: 1px solid rgba(34, 32, 48, 0.1);

        .card_left {
          img {
            width: 40px;
            height: 40px;
            object-fit: cover;
            border-radius: 50%;
          }
        }

        .card_right {
          margin-left: 12px;
          flex: 1;
          .topInfo {
            display: flex;
            justify-content: space-between;
            .username {
              height: 22px;
              display: flex;
              align-items: center;
              font-size: 15px;
              color: #222030;
              font-weight: 600;
              .chosenPic {
                width: 46px;
                height: 100%;
                display: flex;
                align-items: center;
                img {
                  width: 100%;
                  display: block;
                  margin-left: 8px;
                }
              }
            }
            .sendtime {
              font-size: 11px;
              color: rgba(34, 32, 48, 0.45);
            }
            .learnDay {
              color: rgba(34, 32, 48, 0.45);
              font-size: 11px;
              span {
                font-size: 20px;
                color: #fc541e;
                font-weight: 700;
              }
            }
          }
          .homewordContent {
            margin-top: 10px;
            .teacherWord {
              font-size: 15px;
              color: #222030;
            }
            .videoContent {
              width: 108px;
              height: 108px;
              position: relative;
              margin-top: 12px;
              .videoPoster {
                width: 108px;
                height: 108px;
                object-fit: cover;
                border-radius: 6px;
                //  background: rgba(34,32,48,0.25);
              }
              .playicon {
                width: 22px;
                height: 22px;
                position: absolute;
                top: 43px;
                left: 43px;
              }
            }
          }
          .teacherCommend {
            margin-top: 8px;
            padding: 12px;
            box-sizing: border-box;
            border-radius: 6px;
            background: #f6f6f6;
            .commentIcon {
              width: 48px;
              height: 13px;
              object-fit: contain;
            }
            .commentWord {
              font-size: 13px;
              color: #222030;
              margin-top: 14px;
            }
            .picsList {
              display: flex;
              margin-top: 12px;
              .picItem {
                width: 42px;
                margin-left: 3px;
                height: 42px;
                &:nth-of-type(1) {
                  margin: 0;
                }
              }
            }
            .line {
              background: rgba(34, 32, 48, 0.1);
              height: 1px;
              width: 100%;
              margin-top: 12px;
            }
            .teacherInfo {
              display: flex;
              align-items: center;
              margin-top: 8px;
              img {
                width: 20px;
                height: 20px;
                border-radius: 50%;
                object-fit: cover;
              }
              span {
                font-size: 12px;
                display: inline-block;
                margin-left: 8px;
                color: rgba(34, 32, 48, 0.65);
              }
            }
          }
          .pariseNum {
            font-size: 13px;
            margin-top: 8px;
            color: rgba(34, 32, 48, 0.45);
          }
        }
      }
    }
  }
}
</style>

